import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Plugins, Capacitor } from '@capacitor/core';
import {
  IonMenu,
  IonHeader,
  IonToolbar,
  IonList,
  IonItem,
  IonMenuToggle,
  IonButtons,
  IonButton,
  IonIcon,
  IonLabel,
  IonFooter,
  IonAlert,
} from '@ionic/react';
import navConfig from '../../navConfig.js';
import { logout, setDeliveryOption, setOrderTypeRegular } from '../../store/actions';
import { getDefaultRoute, forwardTo, padNumber, isAppVersionValid } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import { SmallText, NormalText, StrongText, Spacer } from '../../components/common';
import packageJson from '../../../package.json';
import SmallDrawer from './smallDrawer';
import { chevronBack, close } from 'ionicons/icons';
import defaultImg from '../../assets/images/gray-avatar.png';
import './index.css';
import { getConfig } from '../../appConfig.js';
import Basket from '../../lib/basket';
import { Device } from '@capacitor/device';
import collectionIcon from '../../assets/images/icons/collection.svg';
import deliveryIcon from '../../assets/images/icons/delivery.svg';
import pickUpIcon from '../../assets/images/icons/drop-point.svg';
import reorderIcon from '../../assets/images/icons/reorder.svg';
import logo5Loyalty from '../../assets/images/5loyalty-white.svg';

const openExternalLink = (url) => window.open(url, '_system', 'location=yes');

const NavItem = withRouter(({ history, item, hideIcon, handleLogout, className, __ }) => {
  const selected = history.location.pathname === item.path;
  return (
    <IonMenuToggle key={item.path} auto-hide="false">
      <IonItem
        lines="none"
        className={
          'nav-item' + (selected ? ' okx-nav-selected' : '') + (className ? ' ' + className : '')
        }
        onClick={() =>
          item.fn === 'logout'
            ? handleLogout()
            : item.isLink
              ? openExternalLink(item.path)
              : forwardTo(item.path, item.state)
        }
      >
        <div tabIndex="-1"></div>
        {hideIcon ? null : <IonIcon className="nav-icon" slot="start" icon={item.icon} />}
        <NormalText className="nav-label">{__(item.label)}</NormalText>
      </IonItem>
    </IonMenuToggle>
  );
});

class Drawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appDeviceVersion: '',
      showPopup: false,
      menuVisible: true,
      logBoxOpen: false,
      profile_image_url: this.props.profile.profile_image_url || defaultImg,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.handleModal = this.handleModal.bind(this);
  }

  handleLogout() {
    this.props.dispatch(logout());
    const defaultRoute = getDefaultRoute();
    forwardTo(defaultRoute.path);
  }

  handleModal(val) {
    this.setState({ showPopup: val });
  }

  async componentDidMount() {
    const info = await Device.getInfo();
    const appDeviceVersion = info.appVersion;
    this.setState({ appDeviceVersion: appDeviceVersion }, () => {
      this.checkVerison();
    });
  }

  addZeros = (arr = []) =>
    arr.map((i, index) => {
      // e.g. 1.23.8
      // skip first number (app version) (e.g. 1)
      // add zeros only to patch (e.g. 23) or minor (e.g. 8)
      if (index !== 0) {
        return padNumber(i, 3);
      }
      return i;
    });

  checkVerison = () => {
    const { appDeviceVersion } = this.state;
    if (Capacitor.getPlatform() !== 'web') {
      if (
        !isAppVersionValid(this.props.appVersion, appDeviceVersion) &&
        appDeviceVersion !== ''
      ) {
        this.handleModal(true);
      }
    } else {
      // web version checking
      if (!isAppVersionValid(this.props.appVersion, packageJson.version)) {
        this.handleModal(true);
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.appVersion !== prevProps.appVersion) {
      this.checkVerison();
    }

    if (this.props.profile.profile_image_url !== prevProps.profile.profile_image_url) {
      if (this.props.profile.profile_image_url) {
        this.setState({ profile_image_url: this.props.profile.profile_image_url });
      } else {
        this.setState({ profile_image_url: defaultImg });
      }
    }
  }

  toggleMenu = () => {
    this.setState({ menuVisible: !this.state.menuVisible }, () => {
      let drawer = this.state.menuVisible
        ? '--okx-drawer-max-width'
        : '--okx-small-drawer-max-width';
      document.documentElement.style.setProperty('--okx-drawer-width', `var(${drawer})`);
    });
  };

  toggleLogBox = () => {
    const { auth } = this.props;
    const { loggedIn } = auth;
    if (loggedIn) {
      this.setState({ logBoxOpen: !this.state.logBoxOpen });
    } else {
      forwardTo('/login');
    }
  };
  isItemActive = (id) => {
    let active = false;
    switch (id) {
      case 'charter-delivery':
        if (
          this.props.history.location.pathname === '/delivery' ||
          this.props.history.location.pathname === '/delivery-address-add' ||
          this.props.history.location.pathname === '/delivery-address-check' ||
          this.props.history.location.pathname === '/delivery-time'
        ) {
          active = true;
        }
        break;
      case 'table':
        if (this.props.history.location.pathname === '/order-to-table') {
          active = true;
        }
        break;
      case 'collection':
        if (this.props.history.location.pathname === '/click-and-collect') {
          active = true;
        }
    }
    return active;
  };
  getDeliveryOptionsIcon = (option) => {
    let icon;
    switch (option.id) {
      case 'delivery':
        icon = deliveryIcon;
        break;
      case 'pick-up-point':
        icon = pickUpIcon;
        break;
      default:
        icon = collectionIcon;
    }
    return icon;
  };
  setDeliveryOption = (option) => {
    this.props.dispatch(setDeliveryOption(option));
    this.props.dispatch(setOrderTypeRegular());
    forwardTo(option.route);
  };
  render() {
    const { auth, __, profile } = this.props;
    const { showPopup, appDeviceVersion, menuVisible, logBoxOpen, profile_image_url } = this.state;
    const { loggedIn } = auth;
    const defaultRoute = getDefaultRoute();
    const routes = navConfig.routes.filter((route) => !!route.path && !route.notInDrawer);

    const groupTitle = [
      { id: 1, title: 'Rewards' },
      { id: 2, title: 'Account' },
      { id: 3, title: 'More' },
    ];
    return (
      <IonMenu className="drawer-menu" side="start" type="overlay" contentId="main">
        {menuVisible ? (
          <>
            <IonHeader>
              <IonToolbar color="tertiary">
                {/*<IonTitle>{ getConfig().theme.nav.label }</IonTitle>*/}
                <div className="nav-logo" onClick={() => forwardTo(defaultRoute.path)}></div>
                <IonIcon
                  icon={chevronBack}
                  className="collapse-drawer-icon"
                  onClick={() => this.toggleMenu()}
                />
                <IonButtons slot="end">
                  <IonMenuToggle>
                    <IonButton button clear>
                      <IonIcon slot="icon-only" icon={close} />
                    </IonButton>
                  </IonMenuToggle>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <div className="sidebar-menu-content">
              <IonMenuToggle autoHide="false">
                <IonButton
                  onClick={() => {
                    Basket.reset();
                    forwardTo('/order');
                  }}
                  className="uppercase drawer-menu-order-button"
                >
                  {__('View Our Menu')}
                </IonButton>
              </IonMenuToggle>

              <IonList>
                <>
                  {getConfig().delivery.filter((d) => !d.isRemoved).length > 0 && (
                    <>
                      <StrongText className="nav-title">{__('Order')}</StrongText>
                      {getConfig().delivery.map((d, index) => {
                        if (d.id == 'reorder') {
                          return <><IonMenuToggle autoHide="false">
                          <IonItem
                            onClick={() => forwardTo('/history')}
                            lines="none"
                            className={'nav-item'}
                          >
                            <IonIcon className="nav-icon" slot="start" icon={reorderIcon} />
                            <NormalText className="nav-label">{__('Order Again')}</NormalText>
                          </IonItem>
                        </IonMenuToggle>
                        </>
                        } else {
                          return <>
                            {!d.isRemoved && (
                              <IonMenuToggle key={index} autoHide="false">
                                <IonItem
                                  lines="none"
                                  disabled={d.isDisabled}
                                  className={
                                    'nav-item' + (this.isItemActive(d.id) ? ' okx-nav-selected' : '')
                                  }
                                  onClick={() => {
                                    Basket.reset();
                                    this.setDeliveryOption(d);
                                  }}
                                >
                                  <IonIcon
                                    className="nav-icon"
                                    slot="start"
                                    icon={this.getDeliveryOptionsIcon(d)}
                                  />
                                  <NormalText className="nav-label">{__(d.label)}</NormalText>
                                </IonItem>
                              </IonMenuToggle>
                            )}
                          </>
                        }

                      })}
              
                    </>
                  )}
                </>
                {groupTitle.map((group, index) => (
                  <div key={index}>
                    <StrongText className="nav-title">{__(group.title)}</StrongText>
                    {routes.map((route, i) => {
                      if (route.group === group.id) {
                        return <NavItem __={__} key={route.path} item={route}/>;
                      }
                    })}
                  </div>
                ))}
              </IonList>
              <a
                className="fiveloyalty-box"
                href="https://www.5loyalty.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SmallText>{__('powered by')}</SmallText>
                <img alt="logo 5Loyalty white" src={logo5Loyalty} />
              </a>
              <Spacer size={1} />
              <a
                className="pointer nav-label small-text"
                onClick={() => window.open('https://www.pure.co.uk/')}
              >
                {__('Back to Pure Website')}
              </a>
            </div>

            <IonFooter className="small-text">
              <IonLabel size="small" slot="start">
                v
                {Capacitor.getPlatform() !== 'web' && appDeviceVersion !== ''
                  ? appDeviceVersion
                  : packageJson.version}
              </IonLabel>
              <NavItem
                className="footer-link"
                __={__}
                handleLogout={this.handleLogout}
                item={navConfig.authRoutes.find(
                  (item) => item.fn === (loggedIn ? 'logout' : 'login'),
                )}
              />
            </IonFooter>
          </>
        ) : (
          <SmallDrawer toggleMenu={this.toggleMenu} />
        )}
        <IonAlert
          isOpen={showPopup}
          onDidDismiss={() => this.handleModal(false)}
          header={__('App version')}
          message={__('Your app is out of date. Please update.')}
          buttons={[
            {
              text: __('OK'),
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => this.handleModal(false),
            },
          ]}
        />
      </IonMenu>
    );
  }
}

const stateToProps = (state) => {
  const { auth, profile } = state.profile;
  const { appVersion } = state.common;
  return {
    auth,
    appVersion,
    profile,
  };
};

export default connect(stateToProps)(withRouter(withTranslation(Drawer)));
